import * as _ from 'lodash';
import { ActionType } from './actions';
import { IAAPDDentist } from '../../classes/dentist';
import { FindAPDSettings } from '../../classes/appSettings';
import axios, { AxiosResponse } from 'axios';
import { Dispatch } from 'react-redux';
import { FindAPDAppState } from '../../classes/redux-states';

export function requestDentists() {
    return {
        type: ActionType.REQUEST_NEXT_BATCH
    }
}

function requestSettings() {
    return {
        type: ActionType.REQUEST_SETTINGS
    }
}

function settingsResponse(response: FindAPDSettings) {
    return {
        type: ActionType.RECIEVE_SETTINGS,
        value: {
            findAPDSettings: response
        }
    }
}

function clearDentistResults() {
    return {
        type: ActionType.CLEAR_RESULTS
    }
}

interface DentistResponse {
    dentists: IAAPDDentist[];
    totalDentists: number;
    totalPages: number;
}

function dentistsResponse(response: DentistResponse) {
    return {
        type: ActionType.RECIEVE_NEXT_BATCH,
        value: {
            dentists: response.dentists,
            totalDentists: response.totalDentists,
            totalPages: response.totalPages
        }
    }
}

export function getSettings() {
    return (dispatch: Dispatch<FindAPDAppState>, getState: () => FindAPDAppState) => {
        let state = getState();
        dispatch(requestSettings());
        axios.get<FindAPDSettings>('/api/v1/dentists/getSettings')
            .then(response => {
                const settings = response.data;
                state = getState();
                dispatch(settingsResponse(settings));
            })
    }
}

export function getDentists(page: number) {
    return (dispatch: Dispatch<FindAPDAppState>, getState: () => FindAPDAppState) => {
        let state = getState();
        let currentPage = page == 0 ? state.findAPDPaginationModel.currentPage : page;
        dispatch(requestDentists());
        axios.post<DentistResponse>('/api/v1/dentists/getDentists',
            {
                CurrentPage: currentPage,
                ZipCode: state.findAPDFiltersModel.zipCode,
                MileRadius: state.findAPDFiltersModel.mileRadius,
                PageSize: state.findAPDFiltersModel.pageSize,
                LastName: state.findAPDFiltersModel.lastName,
                Country: state.findAPDFiltersModel.country,
                State: state.findAPDFiltersModel.state,
                City: state.findAPDFiltersModel.city
            }
        ).then(response => {
            const dentistResponse = response.data;
            //put filtering here
            state = getState();
            dispatch(dentistsResponse(dentistResponse));
        })
    }
}

export function clearResults() {
    return (dispatch: Dispatch<FindAPDAppState>, getState: () => FindAPDAppState) => {
        let state = getState();
        dispatch(clearDentistResults());
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/findapd/redux/actions/find-a-dentist-api.ts